import Icon from '../components/Icon.vue'

Icon.register({
  'traffic-light': {
    width: 384,
    height: 512,
    paths: [
      {
        d: 'M384 192H320V154.1C357.2 140.9 384 105.7 384 64H320V32C320 14.3 305.7 0 288 0H96C78.3 0 64 14.3 64 32V64H0C0 105.7 26.8 140.9 64 154.1V192H0C0 233.7 26.8 268.9 64 282.1V320H0C0 362.8 28.3 398.7 67 411.1 79.4 468.7 130.6 512 192 512S304.6 468.7 317 411.1C355.8 398.7 384 362.8 384 320H320V282.1C357.2 268.9 384 233.7 384 192zM192 416C165.5 416 144 394.5 144 368S165.5 320 192 320 240 341.5 240 368 218.5 416 192 416zM192 288C165.5 288 144 266.5 144 240S165.5 192 192 192 240 213.5 240 240 218.5 288 192 288zM192 160C165.5 160 144 138.5 144 112S165.5 64 192 64 240 85.5 240 112 218.5 160 192 160z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/traffic-light.js
// module id = pUls
// module chunks = 144